import React, { useState,useEffect } from 'react';
import './AddProducts.css';
import { db } from '../../../firebase/Config';
import { collection, addDoc } from 'firebase/firestore';

function AddProducts() {
    const [title, setTitle] = useState('')
    const [category, setCategory] = useState('Mobile')
    const [marketPrice, setMarketPrice] = useState('')
    const [ourPrice, setourPrice] = useState('')
    const [offer, setOffer] = useState('')
    const [deliveropt, setDeliveropt] = useState('Free')
    const [rating, setRating] = useState('')
    const [stock,setStock] = useState('')
    const [totalOrders,setTotalOrders]=useState(0)
    const [details, setDetails] = useState('')
    const [image1, setImage1] = useState('')
    const [image2, setImage2] = useState('')
    const [image3, setImage3] = useState('')
    const [image4, setImage4] = useState('')
    const [image5, setImage5] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(()=>{
        if(marketPrice&&ourPrice){
            const mp=parseFloat(marketPrice)
            const op=parseFloat(ourPrice)
            const off=((mp-op)/mp)*100
            setOffer(off.toFixed(2))
            
        }
    },[marketPrice, ourPrice])
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true)

        try {
            await addDoc(collection(db, 'products'), {
                title,
                category,
                pricing: {
                    marketPrice: parseFloat(marketPrice),
                    ourPrice: parseFloat(ourPrice),
                    offer: parseFloat(offer)
                },
                rating,
                stock,
                details,
                deliveryOption: deliveropt,
                imageUrls: {
                    imageUrl1: image1,
                    imageUrl2: image2,
                    imageUrl3: image3,
                    imageUrl4: image4,
                    imageUrl5: image5
                },
                totalOrders,
                createdAt: new Date()
            })
            setTitle('');
            setCategory('Mobile');
            setMarketPrice('');
            setourPrice('');
            setOffer('');
            setStock('')
            setDeliveropt('Free');
            setImage1('');
            setImage2('');
            setImage3('');
            setRating('');
            setDetails('')
            setImage4('');
            setImage5('');
            alert('Product added successfully!');
        }
        catch (err) {
            alert('Error adding product. Please try again.')
        }
        finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className="product-form-container">
            <div className="product-form-card">
                <h2 className="form-header">Add New Product</h2>
                <form onSubmit={handleSubmit} className="product-form">
                    <div className="form-section">
                        <div className="form-group">
                            <label htmlFor="title">Product Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="category">Category</label>
                            <select
                                name="category"
                                id="category"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                <option value="Mobile">Mobile</option>
                                <option value="Laptop">Laptop</option>
                                <option value="Tablet">Tablet</option>
                                <option value="Cloth">Cloth</option>
                                <option value="Watch">Watch</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="details">Product Details</label>
                            <textarea
                                id="details"
                                name="details"
                                value={details}
                                onChange={(e) => setDetails(e.target.value)}
                                rows="3"
                            />
                        </div>
                    </div>

                    <div className="form-section">
                        <div className="price-group" >
                            <div className="form-group">
                                <label htmlFor="marketPrice">Market Price</label>
                                <input
                                    type="number"
                                    id="marketPrice"
                                    name="marketPrice"
                                    value={marketPrice}
                                    onChange={(e) => setMarketPrice(e.target.value)}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="ourPrice">Our Price</label>
                                <input
                                    type="number"
                                    id="ourPrice"
                                    name="ourPrice"
                                    value={ourPrice}
                                    onChange={(e) => setourPrice(e.target.value)}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="offer">Offer (%)</label>
                                <input
                                    type="number"
                                    id="offer"
                                    name="offer"
                                    value={offer}
                                    readOnly
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="Stock">Stock </label>
                                <input
                                    type="number"
                                    id="Stock"
                                    name="Stock"
                                    value={stock}
                                    onChange={(e) => setStock(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="rating">Rating (1-5 stars)</label>
                            <input
                                type="number"
                                id="rating"
                                name="rating"
                                value={rating}
                                onChange={(e) => setRating(e.target.value)}
                                min="1"
                                max="5"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="delivery">Delivery Option</label>
                            <select
                                id="delivery"
                                value={deliveropt}
                                onChange={(e) => setDeliveropt(e.target.value)}
                            >
                                <option value="Free">Free Delivery</option>
                                <option value="Paid">Paid Delivery</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-section">
                        <div className="form-group">
                            <label>Product Images</label>
                            <input
                                type="text"
                                placeholder="Image URL 1"
                                value={image1}
                                onChange={(e) => setImage1(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Image URL 2"
                                value={image2}
                                onChange={(e) => setImage2(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Image URL 3"
                                value={image3}
                                onChange={(e) => setImage3(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Image URL 4"
                                value={image4}
                                onChange={(e) => setImage4(e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Image URL 5"
                                value={image5}
                                onChange={(e) => setImage5(e.target.value)}
                            />
                        </div>

                        <div className="image-previews">
                            {image1 && (
                                <div className="image-preview">
                                    <img src={image1} alt="Product preview 1" />
                                </div>
                            )}
                            {image2 && (
                                <div className="image-preview">
                                    <img src={image2} alt="Product preview 2" />
                                </div>
                            )}
                            {image3 && (
                                <div className="image-preview">
                                    <img src={image3} alt="Product preview 3" />
                                </div>
                            )}
                            {image4 && (
                                <div className="image-preview">
                                    <img src={image4} alt="Product preview 4" />
                                </div>
                            )}
                            {image5 && (
                                <div className="image-preview">
                                    <img src={image5} alt="Product preview 5" />
                                </div>
                            )}
                        </div>
                    </div>

                    <button type="submit" className="submit-button" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Add Product'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddProducts;